import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import MicIcon from '@mui/icons-material/Mic';
import {  AttachFile, InsertEmoticon, MoreVert, SearchOutlined } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import db from '../firebase';
import "../styles/ChatBox.css";
import { useStateValue } from '../StateProvider';
import firebase from 'firebase/compat/app';

function ChatBox() {
    const [input, setInput] = useState("");
    const [seed, setSeed] = useState('');
    const { roomId } = useParams();
    const [roomName, setRoomName] = useState('');
    const [messages, setMessages] = useState([]);
    const [{user}, dispatch] = useStateValue();
    
    useEffect(() => {
        if (roomId) {
           db.collection('rooms').doc(roomId).onSnapshot((snapshot) => 
            setRoomName(snapshot.data().name));
            
           db.collection("rooms").doc(roomId).collection('messages').orderBy('timestamp', 'asc').onSnapshot((snapshot) => 
            setMessages(snapshot.docs.map((doc) => doc.data())));
        }
    }, [roomId]);

    useEffect(() => {
        setSeed(Math.floor(Math.random() * 5000))
    }, [ roomId ]);


    const sendMessage = (e) => {
        e.preventDefault()
        
        db.collection('rooms').doc(roomId).collection("messages").add({
            message: input,
            name: user.displayName,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });
        console.log("You typed >>>> ",input)
        
        setInput('')
    }

  return (
    <div className="chat">
        <div className="chat__header">
            <Avatar src={`https://avatars.dicebear.com/api/human/${seed}.svg`} />
            
            <div className="chat__headerInfo">
                <h3>{roomName}</h3>
                <p>
                    {new Date(messages[messages.length - 1]?.timestamp?.toDate()).toUTCString()}
                </p>
            </div>
            <div className="chat__headerRight">
                <IconButton>
                    <SearchOutlined/>
                </IconButton>
                <IconButton>
                    <AttachFile/>
                </IconButton>
                <IconButton> 
                    <MoreVert/>
                </IconButton>
            </div>
        </div>

        <div className="chat__body">
            {messages.map((message) => (
            <p className={`chat__message ${message.name === user.displayName && `chat__reciever`}`}>
                {/* If is the user who signed in this will avaluate true */}
            <span className="chat__name">{message.name}</span>
            {message.message}
            <span className="chat__timeStamp">
                {new Date(message.timestamp?.toDate()).toUTCString()} 
            </span>
            </p>
            ))}
        </div>

        <div className="chat__footer">
            <InsertEmoticon/>
            <form action="">
                <input type="text" value={input}
                onChange={(e) => setInput(e.target.value)} 
                placeholder='Type a message'/>
                <button onClick={sendMessage}
                type="submit">Send a message</button>
            </form>
            <MicIcon/>
        </div>
    </div>
  )
}

export default ChatBox; 